export default __webpack_public_path__ + "static/media/1192.19077dc2.png";